import { render, staticRenderFns } from "./markersMap.vue?vue&type=template&id=3555b382&"
import script from "./markersMap.vue?vue&type=script&lang=js&"
export * from "./markersMap.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports